import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { WarningSection } from './components/WarningSection';
import { SolutionSection } from './components/SolutionSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServiceAreas } from './components/ServiceAreas';
import { TransformationSection } from './components/TransformationSection';
import { GallerySection } from './components/GallerySection';
import { EmergencyCTA } from './components/EmergencyCTA';
import { UrgencySection } from './components/UrgencySection';
import { ContactSection } from './components/ContactSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { FloatingContactButton } from './components/FloatingContactButton';
export function App() {
  return <div className="min-h-screen bg-offwhite font-body text-charcoal" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WarningSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <ServiceAreas data-id="element-8" />
        <TransformationSection data-id="element-9" />
        <GallerySection data-id="element-10" />
        <EmergencyCTA data-id="element-11" />
        <UrgencySection data-id="element-12" />
        <ContactSection data-id="element-13" />
        <FAQSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <FloatingContactButton data-id="element-16" />
    </div>;
}